module.exports = __webpack_public_path__ + "static/fighting-infernos-before-they-start-869156b3ef78cb099d84558da66aaef6.jpg";